import insta from "../img/ikony/instagram.svg";
import yt from "../img/ikony/yt.svg";
import github from "../img/ikony/github.svg";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Stopka = styled.div`
  padding: 2vh 0;
  height: auto;
  width: 100%;
  background-color: #2e1919;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #798460;
  @media screen and (max-width: 479px) {
    height: 26vh;
  }
  & > p {
    margin: 0;
    padding: 0;
  }
`;
const Row1 = styled.div`
  height: 10vh;

  width: 20%;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  @media screen and (max-width: 479px) {
    width: 60%;
  }

  & > a > img {
    height: 5vh;
    width: 5vh;
    padding: 0.7vh;
    border: #798460 solid 0.5vh;
    border-radius: 2vh;
  }
`;
const Row2 = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 10vh;

  & > p {
    border-right: #798460 2px solid;
    padding: 0 2vh;
  }
  & > p:last-child {
    border-right: none;
  }
`;
const Linkii = styled(Link)`
  color: #798460;
  font-size: 3vh;
  @media screen and (max-width: 479px) {
    font-size: 1.3rem;
  }
`;
function Footer() {
  function redHolder(x) {
    var count = document.getElementById("TF").children.length;

    for (var i = 1; i < count + 1; i++) {
      document.querySelector("#navPrzycisk" + i).style.backgroundColor =
        "#798460";
    }
    document.querySelector("#navPrzycisk" + x).style.backgroundColor =
      "#5B2632";
  }
  return (
    <Stopka>
      <Row1>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/daniuel_szota/"
        >
          <img alt="brak" src={insta}></img>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/@szootnik2061"
        >
          <img alt="brak" src={yt}></img>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://github.com/Shotnik420"
        >
          <img alt="brak" src={github}></img>
        </a>
      </Row1>
      <Row2>
        <p>
          <Linkii
            onClick={() => {
              redHolder(1);
            }}
            to="/"
          >
            Home
          </Linkii>
        </p>
        <p>
          <Linkii
            onClick={() => {
              redHolder(2);
            }}
            to="/whoami"
          >
            I am
          </Linkii>
        </p>
        <p>
          <Linkii
            onClick={() => {
              redHolder(3);
            }}
            to="/portfolio"
          >
            Portfolio
          </Linkii>
        </p>

        <p>
          <Linkii
            onClick={() => {
              redHolder(4);
            }}
            to="/kontakt"
          >
            Kontakt
          </Linkii>
        </p>
      </Row2>
      <p>Szota &#169; 2023</p>
    </Stopka>
  );
}

export default Footer;
